// extracted by mini-css-extract-plugin
export default {"container":"oO6AwAzTvWkWyUjOiayn"};